import * as forage from '../upchat-sdk/forage';

class API {
  constructor(options) {
    this.options = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers ?? {}),
      },
    };
  }
  fetch(url, data, options) {
    return fetch(this.options.baseURL + url, {
      ...this.options,
      ...options,
      headers: {
        ...this.options.headers,
        ...(options.headers ?? {}),
      },
      ...(data
        ? {
            body: JSON.stringify(data),
          }
        : {}),
    });
  }

  post(url, data, options) {
    return this.fetch(url, data, {
      method: 'POST',
      ...options,
    });
  }

  get(url, searchParams, options) {
    const queryString = new URLSearchParams(searchParams).toString();
    return this.fetch(`${url}?${queryString}`, undefined, {
      method: 'GET',
      ...options,
    });
  }
}

class AgentAPI extends API {
  constructor(baseURL) {
    super({
      baseURL,
    });
    this.initialled = this.auth();
  }
  initialled = new Promise(() => {});
  async auth() {
    const response = await this.get('/user-profile', {
      fingerprint: await forage.getLocalFingerprint(),
    });
    const userProfile = await response.json();
    this.options = {
      ...this.options,
      headers: {
        ...this.options.headers,
        'Anonymou-ID': userProfile.id,
      },
    };
    return true;
  }
  async chatMessages({ content, conversation_id = '' }) {
    await this.initialled;
    const response = await this.post(
      '/chat-messages',
      {
        content,
        conversation_id,
      },
      {
        headers: {
          Accept: 'text/event-stream',
        },
      }
    );
    return response.body;
  }

  async chatMessagesStop({ taskID, user }) {
    if (!taskID || !user) return;
    return this.post(`/chat-messages/${taskID}/stop`, {
      user,
    });
  }
}

export default AgentAPI;
